require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./posts-why-all-the-excitement-about-ai.json") })
        }
      }, "path---posts-why-all-the-excitement-about-ai");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---posts-why-all-the-excitement-about-ai!./.cache/json/posts-why-all-the-excitement-about-ai.json
// module id = 416
// module chunks = 231608221292675